import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "premium-calculator-block__block-card block-card block-card--bg-light-grey" }
const _hoisted_2 = { class: "block-card__content" }
const _hoisted_3 = { class: "premium-calculator-block__form-fieldset premium-calculator-block__form-fieldset--country-selection" }
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = { class: "premium-calculator-block__form-field-container dropdown" }
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = {
  key: 1,
  class: "error"
}
const _hoisted_8 = { class: "premium-calculator-block__form-field-container input-text" }
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = {
  key: 0,
  class: "error"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "premium-calculator-block__form-fieldset premium-calculator-block__form-fieldset--premium-over-12"
}
const _hoisted_13 = { class: "sr-only" }
const _hoisted_14 = { class: "premium-calculator-block__form-field-container input-text" }
const _hoisted_15 = { class: "premium-calculator-block__form-field-container input-text" }
const _hoisted_16 = { class: "premium-calculator-block__form-field-container input-text" }
const _hoisted_17 = { class: "premium-calculator-block__form-field-container dropdown" }
const _hoisted_18 = { class: "premium-calculator-block__form-button-container" }
const _hoisted_19 = ["value"]

import Dropdown from "@premcalc/components/dropdown.vue";
import TextInput from "@premcalc/components/textInput.vue";
import { usePremCalcStore } from "@premcalc/store/premCalcStore";
import { usePremCalcService } from "@premcalc/services/premCalcService";
import { computed, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  setup(__props) {

const store = usePremCalcStore();
const premCalcService = usePremCalcService();

const validCountry = ref(true);
const validMonth = computed(() => {
  return ((store.creditPeriod >= 0 && store.creditPeriod <= 264) && !(store.creditPeriod >= 14 && store.creditPeriod <= 23));
});
const validAmount = computed(() => {
  return (store.amount >= 0 && store.amount <= 100000000);
});
const validDelivery = computed(() => {
  return (store.deliveryTime >= 0 && store.deliveryTime <= 1000);
});
const validInterest = computed(() => {
  return (store.deliveryTime >= 0 && store.deliveryTime <= 1000);
});
const validShortCalculation = computed(() => {
  return validCountry.value && validMonth.value && store.creditPeriod < 14;
});
const validLongCalculation = computed(() => {
  return validCountry.value && validMonth.value && validAmount.value && validDelivery.value && validInterest.value && store.creditPeriod >= 24;
});

const onCalculate = () => {
  store.shortCalculation = null;
  store.longCalculation = null;
  store.noCalculation = false;

  if (store.currentCountry === null) {
    validCountry.value = false;
    return;
  }

  if (validShortCalculation.value) {
    premCalcService.shortCalculation();
  } else if (validLongCalculation.value) {
    premCalcService.longCalculation();
  }
};

watch(() => store.currentCountry, (country) => {
    store.noCalculation = false;
    validCountry.value = store.currentCountry !== null;

    premCalcService.getCountryInfo(country);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("fieldset", _hoisted_3, [
        _createElementVNode("legend", _hoisted_4, _toDisplayString(_unref(store).translations?.shortCreditForm), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_5, [
          _createCommentVNode(" Country "),
          _createVNode(Dropdown, {
            id: 'countries',
            name: 'countries',
            label: _unref(store).translations.country,
            placeholder: _unref(store).translations.selectCountry,
            options: _unref(store).countries,
            modelValue: _unref(store).currentCountry,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).currentCountry) = $event))
          }, null, 8 /* PROPS */, ["label", "placeholder", "options", "modelValue"]),
          (_unref(store).noCalculation)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(store).translations?.noCalculationForCountry), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (!validCountry.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(store).translations?.required), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" Months "),
        _createElementVNode("p", _hoisted_8, [
          _createVNode(TextInput, {
            min: 0,
            max: 264,
            type: 'number',
            id: 'months',
            name: 'months',
            label: _unref(store).translations.creditInMonths,
            tooltip: _unref(store).translations.infoMessageInputMonth,
            valid: validMonth.value,
            validationMessage: _unref(store).translations.creditInMonthsError,
            modelValue: _unref(store).creditPeriod,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).creditPeriod) = $event))
          }, null, 8 /* PROPS */, ["label", "tooltip", "valid", "validationMessage", "modelValue"]),
          (!validMonth.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(store).translations?.creditInMonthsError), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      (_unref(store).errorMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, "store.errorMessage"))
        : _createCommentVNode("v-if", true),
      (_unref(store).creditPeriod > 12)
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(store).translations?.calculationGuide), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (_unref(store).creditPeriod > 12)
        ? (_openBlock(), _createElementBlock("fieldset", _hoisted_12, [
            _createElementVNode("legend", _hoisted_13, _toDisplayString(_unref(store).translations?.longCreditForm), 1 /* TEXT */),
            _createCommentVNode(" Amount "),
            _createElementVNode("p", _hoisted_14, [
              _createVNode(TextInput, {
                min: 0,
                max: 100000000,
                type: 'number',
                id: 'amount',
                name: 'amount',
                label: _unref(store).translations.creditAmount,
                tooltip: _unref(store).translations.infoMessageInputAmount,
                valid: validAmount.value,
                validationMessage: _unref(store).translations.creditAmountError,
                modelValue: _unref(store).amount,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(store).amount) = $event))
              }, null, 8 /* PROPS */, ["label", "tooltip", "valid", "validationMessage", "modelValue"])
            ]),
            _createCommentVNode(" Delivery "),
            _createElementVNode("p", _hoisted_15, [
              _createVNode(TextInput, {
                min: 0,
                max: 1000,
                type: 'number',
                id: 'delivery',
                name: 'delivery',
                label: _unref(store).translations.deliveryTime,
                tooltip: _unref(store).translations.infoMessageInputDelivery,
                valid: validDelivery.value,
                validationMessage: _unref(store).translations.creditDeliveryError,
                modelValue: _unref(store).deliveryTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(store).deliveryTime) = $event))
              }, null, 8 /* PROPS */, ["label", "tooltip", "valid", "validationMessage", "modelValue"])
            ]),
            _createCommentVNode(" Interest "),
            _createElementVNode("p", _hoisted_16, [
              _createVNode(TextInput, {
                min: 0,
                max: 1000,
                step: 0.01,
                type: 'number',
                id: 'interest',
                name: 'interest',
                label: _unref(store).translations.interestRate,
                tooltip: _unref(store).translations.infoMessageInputInterest,
                valid: validInterest.value,
                validationMessage: _unref(store).translations.interestError,
                modelValue: _unref(store).interestRate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(store).interestRate) = $event))
              }, null, 8 /* PROPS */, ["label", "tooltip", "valid", "validationMessage", "modelValue"])
            ]),
            _createCommentVNode(" Currency"),
            _createElementVNode("p", _hoisted_17, [
              _createVNode(Dropdown, {
                id: 'currency',
                name: 'currency',
                label: _unref(store).translations.currency,
                placeholder: _unref(store).translations.selectCurrency,
                options: _unref(store).currency,
                modelValue: _unref(store).currentCurrency,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(store).currentCurrency) = $event))
              }, null, 8 /* PROPS */, ["label", "placeholder", "options", "modelValue"])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("p", _hoisted_18, [
        _createElementVNode("input", {
          value: _unref(store).translations.calculateButtonText,
          onClick: _withModifiers(onCalculate, ["prevent"]),
          type: "submit",
          class: "button"
        }, null, 8 /* PROPS */, _hoisted_19)
      ])
    ])
  ]))
}
}

})